import $ from 'jquery';

export default class ProximityController {
  constructor(element) {
    this.$element = $(element);
    // Declare utility variables.
    this.geolocation = false;
    this.currentLocation = null;
    this.usingCurrentLocation = false;
    // Set callback context.
    this.allow = this.allow.bind(this);
    // Initialize functionality.
    this.setViewState();
    this.listen();
    this.ready();
  }

  setViewState() {
    this.usingCurrentLocation = this.checkboxState;
    // navigator.permissions && navigator.permissions.query({name: 'geolocation'})

    if (navigator.geolocation) {
      this.geolocation = true;
      this.$element.addClass('geolocation');

      // save location for an hour
      const options = {
        maximumAge: 1000 * 60 * 60,
      };

      // Obtain user's current location using the Geolocation API.
      navigator.geolocation.getCurrentPosition(this.allow, null, options);
    }
  }

  allow(position) {
    this.currentLocation = position.coords;
    $(this.$element).closest('.home__communities').addClass('ready');

    if (!this.checkboxState && !this.$textfield.val().length) {
      this.checkboxState = true;
      this.checkboxChangeHandler();
    }
  }

  listen() {
    this.$element.on('submit', this.submitHandler.bind(this));
    this.$checkbox.on('change', this.checkboxChangeHandler.bind(this));
    this.$textfield.on('input', this.textfieldChangeHandler.bind(this));
  }

  checkboxChangeHandler() {
    if (this.checkboxState) {
      this.$textfield.val(null);
      this.$element.trigger('submit');
    }
  }

  textfieldChangeHandler(event) {
    const total = event.target.value.length;

    if (total > 0) {
      this.checkboxState = false;
    } else if (total === 0 && this.usingCurrentLocation && this.geolocation) {
      this.checkboxState = true;
    }
  }

  submitHandler() {
    let location = this.$textfield.val();

    if (this.checkboxState) {
      if (this.geolocation && this.currentLocation) {
        location = `${this.currentLocation.latitude} ${this.currentLocation.longitude}`;
      }
    }

    this.$hiddenfield.val(location);
  }

  ready() {
    this.$element.addClass('ready');
  }

  get checkboxState() {
    return this.$checkbox.get(0).checked;
  }

  set checkboxState(state) {
    this.$checkbox.get(0).checked = state;
  }

  get $checkbox() {
    return this.$element.find('#edit-automatic');
  }

  get $textfield() {
    return this.$element.find('#edit-search');
  }

  get $hiddenfield() {
    return this.$element.find('#edit-location');
  }
}
